<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)"/>
    </ul>
    <div  v-if="showList">
      <ul class="records" v-for="item in historyList" :key="item.inpNo" @click="pushqindan(item)">
        <li>科&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;室：<span>{{ item.deptName }}</span></li>
        <li>押金总额：<span>{{ parseInt(item.inpPrepay) }}</span> 元</li>
        <li>入院时间：<span>{{ item.inpDatetime }}</span></li>
        <li>出院时间：<span>{{ item.outtime }}</span></li>
        <img src="@/assets/appointment/xsj_r.png">
      </ul>
    </div>
    <div class="empty_cl" v-if="!showList">
      <img src="@/assets/bg/empty.png">
      <span>当前暂无住院信息</span>
    </div>
    <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { selectVisitinfos, getIpPatient } from "@/request/api.js";
import { Dialog } from "vant";
export default {
  data() {
    return {
      showNation: false,
      columns: [],
      selectdata: {
        idcardno: ""
      },
      info: {},
      historyList: [],
      showList: false
    };
  },
  created() {
    // console.log(this.$moment(time).format('YYYY-MM-DD'));
    this.getVisitinfos()
  },
  methods: {
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
      this.getInfo();
    },
    // 获取就诊人住院信息
    async getInfo() {
      if(!this.selectdata.patientId){
        Dialog.alert({
          message: "请前往设置默认就诊人"
        }).then(() => {
          this.$router.push("/MedicalCard");
        });
        return;
      };
      let map = {
        patientId: this.selectdata.patientId,
        // patientId: "151442",
        // patientId: "24813",
        userId: "7148"
      };
      let res = await getIpPatient(map);
      if(res.data.obj.resultMsg == "无数据"){
        this.showList = false
        return;
      } else {
        this.showList = true
        res.data.obj.resultData.forEach(item => {
          item.inpDatetime = item.inpDatetime.slice(0,10)
          // item.inpDatetime = item.inpDatetime.replace(/\s{2}/g," ");
          // item.inpDatetime = item.inpDatetime.split(" ")
          // item.inpDatetime = item.inpDatetime[2] +'-'+ item.inpDatetime[0].toString().padStart(2,'0') +'-'+ item.inpDatetime[1].toString().padStart(2,'0')
          if (!item.outtime) {
            this.info = item;
            item.outtime = "未出院"
          } else {
            item.outtime = item.outtime.slice(0,10)
            // item.outtime = item.outtime.replace(/\s{2}/g," ");
            // item.outtime = item.outtime.split(" ")
            // item.outtime = item.outtime[2] +'-'+ item.outtime[0].toString().padStart(2,'0') +'-'+ item.outtime[1].toString().padStart(2,'0')
          }
        });
        this.historyList = res.data.obj.resultData.reverse();
      }
    },
    // 切换就诊卡
    onConfirmNation(value) {
      this.selectdata = value;
      this.showNation = false;
      this.Toast("切换成功");
      this.getInfo()
    },
    cardbtn(item){
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    // 清单详情
    pushqindan(item){
      sessionStorage.setItem("detailedUser", JSON.stringify(item));
      this.$router.push("/Service");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f9f9f9;
  .current_user{
    position: relative;
    margin: 4px 4px 0px 4px;
    padding: 10px;
    background: #E6F5FC;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    >li{
      >span{
        letter-spacing: 0px;
      }
    }
    >li:nth-child(2){
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
  .records{
    position: relative;
    margin: 10px 10px 0px 10px;
    padding: 10px;
    border-radius: 6px;
    background: #fff;
    font-size: 16px;
    color: #999;
    letter-spacing: 1px;
    // font-weight: bold;
    >li{
      margin-top: 4px;
      >span{
        letter-spacing: 0px;
        color: black;
      }
    }
    >li:nth-child(1){
      margin-top: 0px;
    }
    >img{
      position: absolute;
      top: 20px;
      right: 30px;
    }
  }
  .empty_cl{
    text-align: center;
    >img{
      width: 100%;
    }
    >span{
      font-size: 16px;
      letter-spacing: 1px;
      color: rgba(153, 153, 153, 0.8);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Service/GeneralList.vue